var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('collapse'),_c('div',{staticClass:"right-menu"},[_c('screenFull',{staticClass:"right-menu-item"}),_c('userMenu',{staticClass:"right-menu-item",on:{"toPage":_vm.to}})],1)],1),_c('tags-view',{attrs:{"value":_vm.$route},on:{"select-tag":_vm.to,"close":_vm.removeTag}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }